import type { AttendanceStatus, Student } from "../types";

export const todayISO = () => {
  const now = new Date();
  const local = new Date(now.getTime() - now.getTimezoneOffset() * 60_000);
  return local.toISOString().slice(0, 10);
};

export const dateOffsetISO = (days: number) => {
  const date = new Date();
  date.setDate(date.getDate() + days);
  const local = new Date(date.getTime() - date.getTimezoneOffset() * 60_000);
  return local.toISOString().slice(0, 10);
};

export const formatDate = (value: string, options?: Intl.DateTimeFormatOptions) =>
  new Intl.DateTimeFormat("ms-MY", {
    day: "numeric",
    month: "short",
    year: "numeric",
    ...options,
  }).format(new Date(`${value}T00:00:00`));

export const formatDayDate = (value: string) =>
  new Intl.DateTimeFormat("ms-MY", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(new Date(`${value}T00:00:00`));

export const formatTime = (value: string) =>
  new Intl.DateTimeFormat("ms-MY", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  }).format(new Date(value));

export const initials = (name: string) =>
  name
    .split(/\s+/)
    .filter((part) => !["bin", "binti", "a/l", "a/p"].includes(part.toLowerCase()))
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();

export const statusLabel: Record<AttendanceStatus, string> = {
  present: "Hadir",
  late: "Lewat",
  absent: "Tidak hadir",
  excused: "Berizin",
};

export const statusShortLabel: Record<AttendanceStatus, string> = {
  present: "Hadir",
  late: "Lewat",
  absent: "Tidak hadir",
  excused: "Berizin",
};

export const downloadTextFile = (filename: string, content: string, type = "text/plain") => {
  const blob = new Blob(["\ufeff", content], { type: `${type};charset=utf-8` });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
};

export const studentsToCsv = (students: Student[]) => {
  const rows = [
    ["Kod", "Nama Murid", "Kelas", "Jantina", "Kehadiran", "Penjaga", "Telefon"],
    ...students.map((student) => [
      student.code,
      student.name,
      student.className,
      student.gender,
      `${student.attendanceRate}%`,
      student.guardian.name,
      student.guardian.phone,
    ]),
  ];
  return rows
    .map((row) => row.map((cell) => `"${String(cell).replaceAll('"', '""')}"`).join(","))
    .join("\n");
};

